import React from "react";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import bg1 from "./Images/bg_1.jpg";
import Loader from "./Components/Loader";

const Workpage=()=>{
    return(
<>
  <title>JanuShree - Free Bootstrap 4 Template by Colorlib</title>
  <meta charSet="utf-8" />
  <meta
    name="viewport"
    content="width=device-width, initial-scale=1, shrink-to-fit=no"
  />
  <link
    href="https://fonts.googleapis.com/css?family=Montserrat:300,400,600,700"
    rel="stylesheet"
  />
  <link rel="stylesheet" href="css/open-iconic-bootstrap.min.css" />
  <link rel="stylesheet" href="css/animate.css" />
  <link rel="stylesheet" href="css/owl.carousel.min.css" />
  <link rel="stylesheet" href="css/owl.theme.default.min.css" />
  <link rel="stylesheet" href="css/magnific-popup.css" />
  <link rel="stylesheet" href="css/aos.css" />
  <link rel="stylesheet" href="css/ionicons.min.css" />
  <link rel="stylesheet" href="css/bootstrap-datepicker.css" />
  <link rel="stylesheet" href="css/jquery.timepicker.css" />
  <link rel="stylesheet" href="css/flaticon.css" />
  <link rel="stylesheet" href="css/icomoon.css" />
  <link rel="stylesheet" href="css/style.css" />
  {/* <div
    className="hero-wrap js-fullheight"
    style={{ backgroundImage: `url(${bg1})` }}
    data-stellar-background-ratio="0.5"
  >
    <div className="overlay" />
    <div className="container">
      <div
        className="row no-gutters slider-text js-fullheight align-items-center justify-content-center"
        data-scrollax-parent="true"
      >
        <div
          className="col-md-8 ftco-animate text-center"
          data-scrollax=" properties: { translateY: '70%' }"
        >
          <div className="icon">
            <a href="index.html" className="logo">
              <span className="flaticon-flower" />
              <h1>JanuShree</h1>
            </a>
          </div>
          <h1
            className="mb-3 mt-5 bread"
            data-scrollax="properties: { translateY: '30%', opacity: 1.6 }"
          >
            Work
          </h1>
          <p
            className="breadcrumbs"
            data-scrollax="properties: { translateY: '30%', opacity: 1.6 }"
          >
            <span className="mr-2">
              <a href="index.html">Home</a>
            </span>{" "}
            <span>Work</span>
          </p>
        </div>
      </div>
    </div>
  </div> */}
  <Header/>
  {/* END nav */}
  <section className="ftco-section">
    <div className="container">
      <div className="row justify-content-center mb-5 pb-3">
        <div className="col-md-7 heading-section text-center ftco-animate">
          <h2 className="mb-4">Our Work</h2>
          <p className="work-category">
            <span className="px-2">
              <a href="#" className="active">
                All
              </a>
            </span>
            <span className="px-2">
              <a href="#">Make Up</a>
            </span>
            <span className="px-2">
              <a href="#">Massage</a>
            </span>
            <span className="px-2">
              <a href="#">Facial</a>
            </span>
            <span className="px-2">
              <a href="#">Spa</a>
            </span>
            <span className="px-2">
              <a href="#">Hair</a>
            </span>
            <span className="px-2">
              <a href="#">Nail</a>
            </span>
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-md-4 ftco-animate">
          <a href="#" className="work-entry">
            <img
              src="images/work-1.jpg"
              className="img-fluid"
              alt="Colorlib Template"
            />
            <div className="info d-flex align-items-center">
              <div>
                <div className="icon mb-4 d-flex align-items-center justify-content-center">
                  <span className="icon-search" />
                </div>
                <h3>Lips Makeover</h3>
              </div>
            </div>
          </a>
        </div>
        <div className="col-md-4 ftco-animate">
          <a href="#" className="work-entry">
            <img
              src="images/work-2.jpg"
              className="img-fluid"
              alt="Colorlib Template"
            />
            <div className="info d-flex align-items-center">
              <div>
                <div className="icon mb-4 d-flex align-items-center justify-content-center">
                  <span className="icon-search" />
                </div>
                <h3>Hair Style</h3>
              </div>
            </div>
          </a>
        </div>
        <div className="col-md-4 ftco-animate">
          <a href="#" className="work-entry">
            <img
              src="images/work-3.jpg"
              className="img-fluid"
              alt="Colorlib Template"
            />
            <div className="info d-flex align-items-center">
              <div>
                <div className="icon mb-4 d-flex align-items-center justify-content-center">
                  <span className="icon-search" />
                </div>
                <h3>Makeup</h3>
              </div>
            </div>
          </a>
        </div>
        <div className="col-md-4 ftco-animate">
          <a href="#" className="work-entry">
            <img
              src="images/work-4.jpg"
              className="img-fluid"
              alt="Colorlib Template"
            />
            <div className="info d-flex align-items-center">
              <div>
                <div className="icon mb-4 d-flex align-items-center justify-content-center">
                  <span className="icon-search" />
                </div>
                <h3>Lips Makeover</h3>
              </div>
            </div>
          </a>
        </div>
        <div className="col-md-4 ftco-animate">
          <a href="#" className="work-entry">
            <img
              src="images/work-5.jpg"
              className="img-fluid"
              alt="Colorlib Template"
            />
            <div className="info d-flex align-items-center">
              <div>
                <div className="icon mb-4 d-flex align-items-center justify-content-center">
                  <span className="icon-search" />
                </div>
                <h3>Hair Style</h3>
              </div>
            </div>
          </a>
        </div>
        <div className="col-md-4 ftco-animate">
          <a href="#" className="work-entry">
            <img
              src="images/work-6.jpg"
              className="img-fluid"
              alt="Colorlib Template"
            />
            <div className="info d-flex align-items-center">
              <div>
                <div className="icon mb-4 d-flex align-items-center justify-content-center">
                  <span className="icon-search" />
                </div>
                <h3>Makeup</h3>
              </div>
            </div>
          </a>
        </div>
        <div className="col-md-4 ftco-animate">
          <a href="#" className="work-entry">
            <img
              src="images/work-7.jpg"
              className="img-fluid"
              alt="Colorlib Template"
            />
            <div className="info d-flex align-items-center">
              <div>
                <div className="icon mb-4 d-flex align-items-center justify-content-center">
                  <span className="icon-search" />
                </div>
                <h3>Lips Makeover</h3>
              </div>
            </div>
          </a>
        </div>
        <div className="col-md-4 ftco-animate">
          <a href="#" className="work-entry">
            <img
              src="images/work-8.jpg"
              className="img-fluid"
              alt="Colorlib Template"
            />
            <div className="info d-flex align-items-center">
              <div>
                <div className="icon mb-4 d-flex align-items-center justify-content-center">
                  <span className="icon-search" />
                </div>
                <h3>Hair Style</h3>
              </div>
            </div>
          </a>
        </div>
        <div className="col-md-4 ftco-animate">
          <a href="#" className="work-entry">
            <img
              src="images/work-9.jpg"
              className="img-fluid"
              alt="Colorlib Template"
            />
            <div className="info d-flex align-items-center">
              <div>
                <div className="icon mb-4 d-flex align-items-center justify-content-center">
                  <span className="icon-search" />
                </div>
                <h3>Makeup</h3>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div className="row mt-5">
        <div className="col text-center">
          <div className="block-27">
            <ul>
              <li>
                <a href="#">&lt;</a>
              </li>
              <li className="active">
                <span>1</span>
              </li>
              <li>
                <a href="#">2</a>
              </li>
              <li>
                <a href="#">3</a>
              </li>
              <li>
                <a href="#">4</a>
              </li>
              <li>
                <a href="#">5</a>
              </li>
              <li>
                <a href="#">&gt;</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
 
 <Footer/>
  {/* loader */}
  {/* <div id="ftco-loader" className="show fullscreen">
    <svg className="circular" width="48px" height="48px">
      <circle
        className="path-bg"
        cx={24}
        cy={24}
        r={22}
        fill="none"
        strokeWidth={4}
        stroke="#eeeeee"
      />
      <circle
        className="path"
        cx={24}
        cy={24}
        r={22}
        fill="none"
        strokeWidth={4}
        strokeMiterlimit={10}
        stroke="#F96D00"
      />
    </svg>
  </div> */}
</>

    );
}

export default Workpage;